import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';
import { safeResponseJSON } from '../safeJSONParse';
import { throwErrorWithResponse } from '../throwErrorWithResponse';

export const experimentalCopyPageTree: ExperimentalMutations['experimentalCopyPageTree'] = (
	_,
	{
		contentId,
		destinationPageId,
		copyLabels,
		copyPermissions,
		copyDescendants,
		prefix,
		search,
		replace,
		mentionOptions,
	},
	{ network },
) => {
	const params = {
		copyAttachments: true,
		copyProperties: false,
		copyCustomContents: false,
		copyDescendants,
		copyPermissions,
		copyLabels,
		destinationPageId,
		titleOptions: {
			prefix,
			search,
			replace,
		},
		mentionOptions,
	};

	return fetchJSON(network, `/wiki/rest/api/content/${contentId}/pagehierarchy/copy`, {
		method: 'POST',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		body: JSON.stringify(params),
	}).catch(async (reason) => {
		if (network.BadStatusError.isBadStatusError(reason)) {
			const { response } = reason;
			const body = await safeResponseJSON(response);
			if (body) {
				throwErrorWithResponse(body, response);
			}
		}

		throw reason;
	});
};
